export default __webpack_public_path__ + "static/clhbid-logo-for-dark-background-03a9da9cfc47c150b64c5289855a6b1f.svg";